import { Directive, ElementRef, Input, OnInit } from "@angular/core";
import { LogService } from "../services/log.service";

const EventTypes = {
  Click: 'click',
  KeyEnter: 'key.enter',
  MouseOver: 'mouseover',
  KeyDown: 'keydown',
  KeyUp: 'keyup'
};

@Directive({
  selector: '[siteUsageTracker]'
})
export class SiteUsageTrackerDirective implements OnInit {
  @Input() logClick: boolean = true;
  @Input() logMouseOver: boolean = false;
  @Input() logKeyEnter: boolean = false;
  @Input() logKeyDown: boolean = false;
  @Input() logKeyUp: boolean = false;
  @Input() logCategory: string = "Event";
  @Input() logData: number | null = null;
  @Input() logName: string = null;
  @Input() debounceMs: number = 1500;
  /**
   *
   */
  constructor(private eleRef: ElementRef, private logger: LogService) {
  }
  ngOnInit(): void {

    //add events to handle clicks are default
    if(this.logClick)
      this.eleRef.nativeElement.addEventListener(EventTypes.Click, this.logEvent.bind(this));

     if(this.logMouseOver)
      this.eleRef.nativeElement.addEventListener(EventTypes.MouseOver, this.logEvent.bind(this));

    if(this.logKeyEnter)
      this.eleRef.nativeElement.addEventListener(EventTypes.KeyEnter, this.logEvent.bind(this));

    if(this.logKeyDown)
      this.eleRef.nativeElement.addEventListener(EventTypes.KeyDown, this.logEvent.bind(this));

    if(this.logKeyUp)
      this.eleRef.nativeElement.addEventListener(EventTypes.KeyUp, this.logEvent.bind(this));

    this.lastEventTime = {};

  }

  private lastEventTime: { [key: string]: number } = {};

  private logEvent($event): void {
    const now = Date.now();
    const eventKey = `${this.logCategory}_${$event.type}_${this.logName}`;

    if (this.lastEventTime[eventKey] && (now - this.lastEventTime[eventKey] < this.debounceMs)) {
      return; // Skip if event was logged too recently
    }

    let name = this.logName ?? this.eleRef.nativeElement.name;
    this.logger.trackEvent(this.logCategory, $event.type, name, this.logData);
    this.lastEventTime[eventKey] = now;
  }

}
